import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineEdit, AiOutlineMinusCircle, AiOutlinePlus, AiOutlinePlusCircle } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';

const AllClasses = ({setLoading}) => {
  const [formData, setFormData] = useState({
    class_name: '',
  });

    const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [sections, setSections] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedSections, setSelectedSections] = useState({});
  const [newSection, setNewSection] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [selectedClass, setSelectedClass]= useState('');
  const [isEditMode, setIsEditMode] = useState(false);
const [editClassId, setEditClassId] = useState(null);
const [searchTerm, setSearchTerm] = useState('');


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSection = () => {
    const sectionTrimmed = newSection.trim().toUpperCase();

    if (sectionTrimmed && !sections.includes(sectionTrimmed)) {
      setSections((prev) => [...prev, sectionTrimmed]);
      setSelectedSections((prev) => ({
        ...prev,
        [sectionTrimmed]: true,
      }));
      setNewSection('');
    }
  };

  const handleCheckboxChange = (section) => {
    setSelectedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // New: Remove section handler
  const handleRemoveSection = (sectionToRemove) => {
    setSections((prev) => prev.filter((sec) => sec !== sectionToRemove));
    setSelectedSections((prev) => {
      const copy = { ...prev };
      delete copy[sectionToRemove];
      return copy;
    });
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const selected = sections.filter((section) => selectedSections[section]);
  const sectionsString = selected.join(',');

  const payload = {
    class_name: formData.class_name,
    sections: sectionsString,
  };

  try {
    let response;

    if (isEditMode) {
      response = await fetch(`https://api.kcian.in/update-class/${editClassId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } else {
      response = await fetch('https://api.kcian.in/add-class', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    }

    setLoading(false);

    if (!response.ok) {
      setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Server response:', data);

    fetchClasses();
    setResponse2({ message: data.message || (isEditMode ? 'Class updated successfully' : 'Class added successfully'), status: 'success' });

    // Reset form
    setFormData({ class_name: '' });
    setSections([]);
    setSelectedSections({});
    setNewSection('');
    setIsEditMode(false);
    setEditClassId(null);

    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  } catch (error) {
    setLoading(false);
    console.error('Error sending data:', error);
  }
};

    const fetchClasses = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-classes');
      
                      if (response.ok) {
                          const data = await response.json();
                          setClasses(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch class');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }

    useEffect(() => {
        fetchClasses();
    }, []);



    const handleShowDelete = (cls) => {
    setSelectedClass(cls);
    setShowDelete(true);
  }


              const handleDelete = async (clsId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-class/${clsId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setClasses((prevData) => prevData.filter((product) => product.id !== clsId));
        setShowDelete(false);
        setResponse2({ message: 'Class Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };


const handleEditClass = (cls) => {
  setFormData({
    class_name: cls.class_name,
  });

  const sectionList = cls.sections?.split(',') || [];

  setSections(sectionList);

  const selectedMap = {};
  sectionList.forEach((sec) => {
    selectedMap[sec] = true;
  });

  setSelectedSections(selectedMap);
  setEditClassId(cls.id);
  setIsEditMode(true);
};


  const filteredCls = classes.filter(cls => {
  const term = searchTerm.toLowerCase();
  return (
    cls.class_name.toLowerCase().includes(term)
  );
});


  return (
    <>
      <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Classes" message2="All Classes" />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<div className='row'>

<div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>

          <div className="profile-card">
            <p className="profile-heading">Add Class</p>

            <form onSubmit={handleSubmit} className='mt-4'>
              {/* Class Name */}
              <div className="mb-4">
                <div className="profile-input-area">
                  <label className="profile-badge">Class Name*</label>
                  <input
                    type="text"
                    name="class_name"
                    value={formData.class_name}
                    onChange={handleChange}
                    className="profile-input"
                    required
                  />
                </div>
              </div>

              {/* Sections Input and Add Button */}
              <div className="mb-4 d-flex align-items-center gap-2">
                <div className="profile-input-area w-100">
                                  <label className="profile-badge">Select Section*</label>
                  <input
                    type="text"
                    placeholder="Add Section (e.g. A)"
                    value={newSection}
                    onChange={(e) => setNewSection(e.target.value)}
                    className="profile-input"
                  />
                </div>
                  <button
                    type="button"
                    className="border-0 bg-transparent cursor-pointer"
                    onClick={handleAddSection}
                    disabled={!newSection.trim()}
                  >
                    <AiOutlinePlusCircle size={30} />
                  </button>
              </div>

              <div className="mb-4">
                <label className="profile-badge">Select Sections*</label>
                <div>
                  {sections.length === 0 && (
                    <small className="text-muted fw-semibold">No Sections Added yet.</small>
                  )}
                  {sections.map((section) => (
                    <div key={section} className="d-flex align-items-center mb-2">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        id={`section-${section}`}
                        checked={!!selectedSections[section]}
                        onChange={() => handleCheckboxChange(section)}
                      />
                      <label
                        className="form-check-label me-3"
                        htmlFor={`section-${section}`}
                        style={{ userSelect: 'none' }}
                      >
                        {section}
                      </label>
                      <button
                        type="button"
                    className="border-0 bg-transparent cursor-pointer"
                        onClick={() => handleRemoveSection(section)}
                      >
                        <AiOutlineMinusCircle size={24} color='red' />
                      </button>
                    </div>
                  ))}
                </div>
              </div>

<div className='text-center'>
    
              <button type="submit" className="profile-btn me-2">
{isEditMode ? <><AiOutlineEdit /> Update</> : <><AiOutlinePlus /> Add</>}
              </button>
              {isEditMode && (
    <button
      type="button"
      className="profile-btn2"
      onClick={() => {
        setFormData({ class_name: '' });
        setSections([]);
        setSelectedSections({});
        setNewSection('');
        setIsEditMode(false);
        setEditClassId(null);
      }}
    >
      Cancel
    </button>
)}
</div>
            </form>
          </div>
{/* left inner ends */}
</div>
{/* left ends */}


<div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
<div className='profile-card'>

  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">Class List</span>


                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>S No</th>
    <th>Class</th>
    <th>Sections</th>
    <th>Students</th>
    <th className='rounded-end-4'>Activity</th>
</thead>


{filteredCls.map((cls, index) => (
  <tr className='account-tr'>
    <td>{index+1}</td>
    <td>{cls.class_name}</td>
    <td>{cls.sections}</td>
    <td>{cls.description || '-'}</td>
    <td><MdOutlineEdit className='account-icon1' title='Edit' onClick={() => handleEditClass(cls)} /> &nbsp;&nbsp;<RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(cls)} /></td>
  </tr>
))}

</table>
</div>
{/* table ends */}

</div>
</div>
{/* right ends */}


</div>
{/* row ends */}


        </div>
      </section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Class!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Class</th>
    <th className='rounded-end-4'>Sections</th>
</thead>

<tr className='account-tr'>
<td>{selectedClass.class_name}</td>
<td>{selectedClass.sections}</td>

</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Class will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedClass.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  );
};

export default AllClasses;
